import modelsResolver from '../utils/modelsResolver';
import { SingleSubscription } from './singleSubscription';

export type Subscriptions = {
	_subscriptions: any;
	subscriptions: SingleSubscription[];
};

const model: any = {
	_subscriptions: ['response', []],
	subscriptions: (model: Subscriptions) => {
		return model._subscriptions.map((subscription: any) => {
			return modelsResolver(subscription, 'singleSubscription');
		});
	},
};

export default model;
